import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/rootReducer";
import thunk from "redux-thunk";
import { IS_DEV } from "./constants";
var composeEnhancers = IS_DEV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
export var getAppReducer = function getAppReducer() {
  return store.getState().appReducer;
};
export default store;